//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "vux";
import { mapState } from "vuex";
import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import UserHeader from "./UserHeader";
import { Col, Row } from 'vant';
import BaseNoticeItem from "../../components/BaseNoticeItem";

export default {
  data() {
    return {
      baseNoticeList: []
    };
  },
  components: {
    UserHeader,
    BaseNoticeItem
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      menus: (state) => state.user.menus,
      responsibilityId: (state) => state.user.responsibilityId,
    }),
    respMenus: {
      get() {
        return this.initMenus()
      },
      set(val) {},
    },
  },
  created() {},
  activated: function () {},
  methods: {
    // 返回按钮点击事件
    onClickLeft() {
      this.$router.back();
    },
    goToPage(type) {
      // 根据类型跳转到对应页面
      switch(type) {
        case 'bidding':
          // 竞价/单一来源报价页面
          this.$router.push({
            name: 'biddingPage',
            params: {},
            query: {}
          })
          break;
        case 'inquiry':
          // 询价报价页面
          this.$router.push({
            name: 'inquiryPage',
            params: {},
            query: {}
          })
          break;
        case 'priceCorrection':
          // 价格更正页面
          this.$router.push({
            name: 'priceCorrectionPage',
            params: {},
            query: {}
          })
          break;
      }
    }
  },
  watch: {},
  mounted() {
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/home/Home.vue